// Keeps Nutravey's muted background videos playing. Each starts as soon as it can,
// retries when autoplay is held (iOS Low Power Mode, a tab opened in the background),
// and a video with data-src instead of src loads once it nears the viewport.
if (!customElements.get('nv-video-autoplay')) {
  customElements.define(
    'nv-video-autoplay',
    class NvVideoAutoplay extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.video = document.getElementById(this.dataset.video);
        if (!this.video) return;
        this.ready = true;
        this.play = this.play.bind(this);

        // The video stays hidden until it plays, so a held autoplay never shows the browser's play button.
        const reveal = () => this.video.classList.add('is-playing');
        if (!this.video.paused && this.video.readyState > 2) reveal();
        this.video.addEventListener('playing', reveal, { once: true });

        // Only these events count as the visitor allowing playback (touchstart doesn't on iOS).
        ['click', 'touchend', 'keydown'].forEach((type) =>
          document.addEventListener(type, this.play, { passive: true })
        );
        document.addEventListener('visibilitychange', this.play);

        // Off screen a video stops decoding frames; it picks up again once it's back in view.
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            if (this.inView) {
              this.play();
            } else if (!this.video.paused) {
              this.video.pause();
            }
          }).observe(this.video);
        }

        if (this.video.dataset.src) {
          this.loadWhenNear();
        } else {
          this.play();
        }
      }

      loadWhenNear() {
        const gate = window.nvVideo;
        // A slow connection never fetches the clip; the poster is the section.
        if (gate && gate.slow) return;
        const load = () => {
          this.video.src = this.video.dataset.src;
          this.video.removeAttribute('data-src');
          if (gate) gate.watch(this.video);
          this.play();
        };
        if (!('IntersectionObserver' in window)) return load();

        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            load();
          },
          { rootMargin: '400px 0px' }
        );
        observer.observe(this.video);
      }

      // Hidden tabs are left to the autoplay attribute; visibilitychange picks them up.
      play() {
        if (!this.video.paused || this.video.dataset.src || this.video.dataset.nvGaveUp || document.hidden || this.inView === false) return;
        const playing = this.video.play();
        if (playing && playing.catch) playing.catch(() => {});
      }
    }
  );
}
